/**
 * An object to save the count of action elements, e.g. for material
 */
export interface IDataSetActionFieldCount {
    /** Identifier of of the action section */
    identifier: string;
    /** Optional also the name string of the action section */
    name?: string;
    /** The number of items added */
    fieldCount: number;
}

export class DataSetActionFieldCount implements IDataSetActionFieldCount {
    public identifier: string;
    public fieldCount: number;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDataSetActionFieldCount);
    constructor(obj?: any) {
        this.identifier = obj && obj.identifier || '';
        this.fieldCount = obj && obj.fieldCount || 0;
    }
}
